var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimespentTaskEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 634133"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "document-text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.6666 50.6666V64C81.6666 77.3333 76.3333 82.6666 63 82.6666H47C33.6666 82.6666 28.3333 77.3333 28.3333 64V48C28.3333 34.6666 33.6666 29.3333 47 29.3333H60.3333",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6666 50.6666V64C81.6666 77.3333 76.3333 82.6666 63 82.6666H47C33.6666 82.6666 28.3333 77.3333 28.3333 64V48C28.3333 34.6666 33.6666 29.3333 47 29.3333H60.3333",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M81.6667 50.6666H71C63 50.6666 60.3333 48 60.3333 40V29.3333L81.6667 50.6666Z",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M36.6667 45.6667H52.6667",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M37 54H57",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M37 62H60",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M37 70H68",
    stroke: "#EFEFEF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M91.6667 72C91.6667 78.44 86.44 83.6666 80 83.6666C73.56 83.6666 68.3333 78.44 68.3333 72C68.3333 65.56 73.56 60.3333 80 60.3333C86.44 60.3333 91.6667 65.56 91.6667 72Z",
    fill: "white",
    stroke: "#EFEFEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M84.3283 75.71L80.7117 73.5517C80.0817 73.1783 79.5683 72.28 79.5683 71.545V66.7617",
    stroke: "#EFEFEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimespentTaskEmpty);
export default __webpack_public_path__ + "static/media/timespentTaskEmpty.83f3a3acab8783f174c0ea6e94ff3dc0.svg";
export { ForwardRef as ReactComponent };